import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { RANGES, STATUS_COLORS } from "@/lib/constants";

export function KpiCard({ label, value, sub, accent = "#E8752A", testid }) {
  return (
    <div data-testid={testid} className="bg-white rounded-2xl border border-slate-200 p-5 shadow-sm relative overflow-hidden fade-up">
      <div className="absolute top-0 left-0 right-0 h-1" style={{ background: accent }} />
      <p className="text-xs uppercase font-bold tracking-[0.14em] text-slate-500">{label}</p>
      <p className="font-mono-num text-3xl sm:text-4xl font-extrabold tracking-tight text-[#081226] mt-2">{value}</p>
      {sub && <p className="text-xs text-slate-400 mt-1">{sub}</p>}
    </div>
  );
}

export function StatusBadge({ status }) {
  return (
    <span className={`inline-block text-[11px] font-bold px-2.5 py-1 rounded-full whitespace-nowrap ${STATUS_COLORS[status] || "bg-slate-100 text-slate-600"}`}>
      {status}
    </span>
  );
}

export function RangeSelect({ value, onChange, testid = "range-select" }) {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[150px] bg-white h-10 rounded-xl border-slate-200 font-semibold" data-testid={testid}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {RANGES.map((r) => <SelectItem key={r.value} value={r.value}>{r.label}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6">
      <div>
        <h1 className="font-display text-2xl sm:text-3xl font-extrabold tracking-tight text-[#081226]">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      <div className="flex items-center gap-3">{children}</div>
    </div>
  );
}

export function Panel({ title, children, className = "", action }) {
  return (
    <div className={`bg-white rounded-2xl border border-slate-200 shadow-sm ${className}`}>
      {title && (
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <h3 className="font-display font-bold text-[#081226]">{title}</h3>
          {action}
        </div>
      )}
      <div className="p-5">{children}</div>
    </div>
  );
}

export function EmptyState({ text }) {
  return <div className="text-center py-12 text-slate-400 text-sm">{text}</div>;
}
